import SectionHeading from "./SectionHeading";
import { latestUpdates } from "@/mocks/site";

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-10">
        <SectionHeading
          eyebrow="最新更新 · 实时刷新"
          title="刚刚更新的漫画章节"
          desc="按发布时间倒序展示最近上新的章节。想确认某部作品是否还在稳定连载，从这里看更新时间最直观。"
          tone="accent"
        />

        <div className="mt-10 rounded-lg border border-background-200/70 bg-background-50 overflow-hidden">
          <div className="hidden md:grid grid-cols-12 gap-4 px-5 py-3 bg-background-200/60 text-foreground-500 text-xs md:text-sm">
            <span className="col-span-6">作品名称</span>
            <span className="col-span-2">分类</span>
            <span className="col-span-2">最新章节</span>
            <span className="col-span-2 text-right">更新时间</span>
          </div>
          <ul>
            {latestUpdates.map((item) => (
              <li
                key={`${item.title}-${item.chapter}`}
                className="grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-4 px-5 py-4 border-t border-background-200/60 hover:bg-primary-50/50 transition-colors"
              >
                <div className="md:col-span-6 flex items-center gap-2 min-w-0">
                  <span className="w-7 h-7 rounded-md bg-accent-100 text-accent-600 flex items-center justify-center text-sm shrink-0">
                    <i className="ri-flashlight-line" aria-hidden="true"></i>
                  </span>
                  <h3 className="text-foreground-950 text-sm md:text-base font-medium truncate">{item.title}</h3>
                </div>
                <div className="md:col-span-2 flex items-center">
                  <span className="rounded-full bg-secondary-100 text-secondary-900 text-xs px-2.5 py-0.5">{item.category}</span>
                </div>
                <div className="md:col-span-2 flex items-center text-foreground-700 text-sm">
                  <span className="md:hidden text-foreground-400 mr-2 text-xs">章节</span>
                  {item.chapter}
                </div>
                <div className="md:col-span-2 flex md:justify-end items-center text-foreground-500 text-xs md:text-sm">
                  <span className="md:hidden text-foreground-400 mr-2 text-xs">更新</span>
                  {item.time}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}